import cat_img_1 from "./images/cat_1.svg";
import cat_img_2 from "./images/cat_2.svg";
import cat_img_3 from "./images/cat_3.svg";

export const categoryMiddleData = [
    {
        label: "Discounts & Offers",
        image: cat_img_1,
        alt_text: "cat_img_1",
        link: "/category/discounts-offers-juc442_7",
    },
    {
        label: "New Products",
        image: cat_img_2,
        alt_text: "cat_img_2",
        link: "/products",
    },
    {
        label: "Bio Products",
        image: cat_img_3,
        alt_text: "cat_img_3",
        link: "/bio-products",
    },
    // {
    //     label: "Recipes",
    //     image: '/icon/desktop/mbs-3.svg',
    //     alt_text: "cat_img_4",
    //     link: "/",
    // },
    {
        label: "Desi Family",
        image: "/icon/desktop/desi_family_icon.svg",
        alt_text: "cat_img_5",
        link: "/desi-family",
    },
    // {
    //     label: "Gift Cards",
    //     image: '/icon/desktop/gift_card_icon.svg',
    //     alt_text: "cat_img_6",
    //     link: "/",
    // },
    // {
    //     label: "Desi Blog",
    //     image: '/icon/desktop/desi_blogs_icon.svg',
    //     alt_text: "cat_img_8",
    //     link: "/",
    // },
];
